<template lang="pug">
.register-row
  .register-group
    .register-key(v-if="keyName")
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須
      slot(name="question")

    slot(name="description")

    .register-value 
      textarea.register-form(
        v-model="_value"
        :name="name"
        :placeholder="placeholder"
        v-validate="validationRules"
        :maxlength="maxlength"
        :rows="rows"
        :data-vv-as="(validationKeyName) ? validationKeyName : keyName"
        :style="styles"
        :class="{ noinput: (required == true && !_value) }")

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * テキストエリア要素コンポーネント
 *
 * - 単一の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormTextarea extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 項目名 */
  @Prop({ type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** 行数 */
  @Prop({ type: Number })
  rows!: number;

  /** 最大長 */
  @Prop({ type: Number })
  maxlength!: number;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }
}
</script>
